import React from 'react';
import { connect } from 'react-redux';

import { actionShared } from '../../containers/Widget/actions.js';

import LargeShareButton from './LargeShareButton';

import FacebookIcon2 from '../Svg/FacebookIcon';
import PropTypes from 'prop-types';
import { copyFor } from '../../copy/copy';
import config from '../../config';

const facebookClickAction = (widgetRequestId, altSharingText,altSharingURL) => {
    const link = altSharingURL || config['SHARE_URL'] + `?widgetId=${widgetRequestId}`;
    const url = `https://www.facebook.com/sharer/sharer.php?u=${link}&quote=${altSharingText}`;
    window.open(url, 'popup', 'width=600,height=600');
    return true;
};

const FacebookShare = props => (
    <LargeShareButton
        color="#33589e"
        handleClick={() =>
            facebookClickAction(
                props.widgetRequestId,
                props.altSharingText || props.altSharingDefaultText,
                props.altSharingURL
            ) && props.actionShared('facebook')
        }
        isShort={props.isShort}
    >
        <FacebookIcon2 width={30} height={17} viewBox="0 0 20 20" />
        {copyFor('sharing', 'largeFacebookShareButton' + (props.isMobileResolution ? 'Mobile' : ''))}
    </LargeShareButton>
);

FacebookShare.propTypes = {
    shareUrl: PropTypes.string.isRequired,
    actionShared: PropTypes.func.isRequired,
    isEmbed: PropTypes.bool.isRequired,
    widgetRequestId: PropTypes.string.isRequired,
    altSharingText: PropTypes.string,
    altSharingDefaultText: PropTypes.string,
    altSharingURL: PropTypes.string,
    isShort: PropTypes.bool
};

export default connect(
    (state, props) => ({
        isEmbed: state.widget.articleUrl.includes('embed'),
        widgetRequestId: state.widget.widgetRequestId,
        shareUrl: state.widget.articleUrl,
        altSharingText: props.altSharingCustomText || state.widget.activeAction.altSharingFacebookMessage,
        isMobileResolution: state.widget.isMobileResolution
    }),
    {
        actionShared
    }
)(FacebookShare);
